import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReadingTarot = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "cards-02 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M18.6667 9.33333H6.66667C5.19391 9.33333 4 10.5272 4 12V26.6667C4 28.1395 5.19391 29.3333 6.66667 29.3333H18.6667C20.1395 29.3333 21.3333 28.1395 21.3333 26.6667V12C21.3333 10.5272 20.1395 9.33333 18.6667 9.33333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M15.4099 16.2758C13.8132 15.4829 12.6667 16.6517 12.6667 16.6517C12.6667 16.6517 11.5202 15.4829 9.92352 16.2758C7.98962 17.2361 7.85074 20.997 12.6667 22.6666C17.4827 20.997 17.3437 17.2361 15.4099 16.2758Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M21.3577 26.6663L27.0767 11.2994C27.5877 9.92625 26.8952 8.39804 25.526 7.87695L14.3443 3.62172C12.9606 3.09519 11.4129 3.79647 10.8966 5.18391L9.33333 9.38433",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgReadingTarot;
